import {CHANGE_LANG} from '../constants/actionTypes'

const initialState = {lang:"tr" };

const LangReducer = (state = initialState,action) => {

    switch (action.type){

        case CHANGE_LANG:
            return {
                ...state,
                lang:action.payload
            };
        default:
            return state;
    }
};

export default LangReducer;
